module.exports = __webpack_public_path__ + "static/media/success_pay.7490d42e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/success_pay.png
// module id = 612
// module chunks = 0